import { core } from '../core/index.js';

export type FabricWebviewSwitchTabOptions = {
  /**
   * 需要跳转的 tabBar 页面的索引值 `0,1,2,3,4`
   */
  index: number;
  /**
   * 是否要清理掉当前tab中已启动的栈列表, Android所有tab共享一个栈, always会清掉, 此配置只针对IOS
   * @default true
   */
  cleanStacks?: boolean;
};

export type FabricWebviewSwitchTabApi = (
  options: FabricWebviewSwitchTabOptions
) => void;

/**
 * 跳转到 tabBar 页面，并关闭其他所有非 tabBar webview页面
 */
export const switchTab: FabricWebviewSwitchTabApi = (
  options: FabricWebviewSwitchTabOptions
) => {
  core.call<'fabric_webview.switchTab', FabricWebviewSwitchTabOptions>(
    'fabric_webview.switchTab',
    {
      index: options.index,
      cleanStacks: options.cleanStacks !== false,
    }
  );
};
